module.exports = __webpack_public_path__ + "img/M-cover.90540607.png";